import { useRef } from "react";
import { FiUploadCloud } from "react-icons/fi";
import ParkingServices from "services/ParkingServices";
import { notifySuccess, notifyError } from "utils/toast";

const UploadData = ({ onUploaded }) => {
  const inputRef = useRef();

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return notifyError("No file selected");

    // try {
    //   const res = await ParkingServices.bulkUpload(file);
    //   // console.log("data from bulk upload", res);
      
    //   notifySuccess("Updated " + res.result.updated.length + " Records");
    //   notifySuccess("Inserted " + res.result.inserted.length + " Records");

    //   if (res.result.errors && res.result.errors.length > 0) {
    //     res.result.errors.forEach((err) => {
    //       notifyError(err.message);
    //     });
    //   }

    //   if (typeof onUploaded === "function") {
    //     onUploaded(res);
    //   }
    // } 
    try {
    const res = await ParkingServices.bulkUpload(file);

    if (res.result) {
      if (res.result.updated.length > 0) {
        notifySuccess(`Updated ${res.result.updated.length} records`);
      }
      if (res.result.inserted.length > 0) {
        notifySuccess(`Inserted ${res.result.inserted.length} records`);
      }

      // Show all validation errors as toast
      if (res.result.errors && res.result.errors.length > 0) {
        res.result.errors.forEach((err) => {
          notifyError(err.message);
        });
      }

      if (typeof onUploaded === "function") onUploaded(res);
    }
  }
    catch (err) {
       if (err.response && err.response.data && err.response.data.error) {
      notifyError(err.response.data.error);
    } else if (err.message) {
      notifyError(err.message);
    } else {
      notifyError("Upload failed");
    }
    } finally {
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex flex-grow-0">
      <div className="flex-1">
        <label
          className="border flex justify-center items-center gap-2 border-gray-300 
                     hover:border-green-400 hover:text-green-400 dark:text-gray-300 
                     cursor-pointer h-10 w-20 rounded-md focus:outline-none min-h-[50px]"
        >
          <FiUploadCloud className="text-lg" />
          <span className="text-xs">Upload</span>
          <input
            ref={inputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            className="hidden"
            onChange={handleUpload}
          />
        </label>
      </div>
    </div>
  );
};

export default UploadData;
